import { render, staticRenderFns } from "./AssetsView.vue?vue&type=template&id=64a168a5&scoped=true"
import script from "./AssetsView.vue?vue&type=script&lang=js"
export * from "./AssetsView.vue?vue&type=script&lang=js"
import style0 from "./AssetsView.vue?vue&type=style&index=0&id=64a168a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a168a5",
  null
  
)

export default component.exports